
import { toJS } from "mobx";
import * as APITypes from "../../../../../src/constants/API";
import axios from "axios";

import OptimizationStore from "../../../../modules/optimization/store/OptimizationStore"

const updateProductDataForCompateProduct = async (updatedBIRequest) => {

    let response = await axios.post(APITypes.RECALCULATE_FOR_BI_DATA_FOR_COMAPARE_PRODUCTS, updatedBIRequest);

    let productData = toJS(OptimizationStore.recommendedProductData)
    if (response.status === "success") {
        let jsonOutputData = JSON.parse(response.data?.JsonOutput);
        let biData2 = [];
        if (jsonOutputData && jsonOutputData.hasOwnProperty("BIJson2") && jsonOutputData?.BIJson2
        ) {
            biData2 = JSON.parse(jsonOutputData.BIJson2);
        } else {
            biData2 = JSON.parse(jsonOutputData.BIJson);
        }
        
        if (jsonOutputData.Status === "Success") {
            productData.map((item, index) => {

                if (Number(item.data.package_id) === Number(updatedBIRequest.packageId)) {
    
                    item.data.biResponseCompleteData = biData2
                    item.data.firstYearResponse = biData2[0]
                    item.data.parsedResponse = biData2[biData2.length - 1]
                    item.data.quotationId = response?.data?.quotation_id
                    item.data.fieldChanged = false
    
                }
            })
            OptimizationStore.updateComapareProductData(productData)
    
        }else{
            OptimizationStore.showErrorMsg(jsonOutputData);
        }
    }
}
export default updateProductDataForCompateProduct